import { ChangeDetectorRef, ComponentFactoryResolver, EventEmitter, ViewChild, ViewContainerRef, Directive } from '@angular/core';
import { MachineLearningResetWizardService } from '../../services/machine.learning/machine-learning-reset-wizard.service';
import { ActivatedRoute } from '@angular/router';
import { WizardComponent } from '../../wizard.component';
import { Subscription } from 'rxjs';
import { get } from 'lodash';

@Directive()
export abstract class MachineLearningWizardComponent extends WizardComponent {
  wizardService: MachineLearningResetWizardService;
  changeDetectorRef: ChangeDetectorRef;
  activatedRoute: ActivatedRoute;
  wizardId: string;
  wizardConfig: any;
  onClose = new EventEmitter<any>();
  activatedRouteSubscription: Subscription;
  queryParams: any;

  @ViewChild("contentPlaceholder", { read: ViewContainerRef,
static: true })
  contentRef: ViewContainerRef;
  @ViewChild("subContentPlaceholder", { read: ViewContainerRef,
static: true })
  subContentRef: ViewContainerRef;

  constructor(
    wizardService: MachineLearningResetWizardService,
    changeDetectorRef: ChangeDetectorRef,
    activatedRoute: ActivatedRoute,
    private readonly factoryResolver: ComponentFactoryResolver
  ) {
    super();
    this.wizardService = wizardService;
    this.changeDetectorRef = changeDetectorRef;
    this.activatedRoute = activatedRoute;
  }

  ngOnInit() {
    this.activatedRouteSubscription = this.activatedRoute.queryParams.subscribe((params) => {
      this.queryParams = params;
      const defaultParams = JSON.parse(get(this.queryParams, 'defaultParams', "{}"));
      this.wizardService.openWizard(this.wizardId, this.wizardConfig, defaultParams);
    });
  }

  ngAfterViewInit() {
    this.createContentComponent();
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy() {
    if(this.activatedRouteSubscription) {
      this.activatedRouteSubscription.unsubscribe();
    }
  }

  //-------------- Control && Validation -----------------------
  toggleClose() {
    this.wizardService.toggleClose(
      () => this.onClose.emit(true)
    );
  }

  getWizardService() {
    return this.wizardService;
  }

  getFactoryResolver() {
    return this.factoryResolver;
  }

  getContentViewRef() {
    return this.contentRef;
  }

  getSubContentViewRef() {
    return this.subContentRef;
  }

  abstract resolveComponentType();
}
